import Model from "./Model";
import Taxonomy from "@/interfaces/Taxonomy";

export default class ProductSector extends Model implements Taxonomy {
  static type = "productSectors";

  name!: string;
  categories?: Array<Taxonomy>;
  classes?: Array<Taxonomy>;

  get type(): string {
    return ProductSector.type;
  }
}
